document.addEventListener('DOMContentLoaded', () => {
    const currency = new Intl.NumberFormat(document.documentElement.lang || 'de', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    const styles = getComputedStyle(document.body);
    const primary = styles.getPropertyValue('--calcimo-primary').trim();
    const secondary = styles.getPropertyValue('--calcimo-secondary').trim();

    const renderChart = (canvas, labels, datasets) => {
        new Chart(canvas.getContext('2d'), {
            type: 'line',
            data: { labels, datasets },
            options: {
                maintainAspectRatio: false,
                legend: { display: true },
                scales: {
                    yAxes: [{
                        ticks: {
                            callback: (value) => currency.format(Number(value) || 0),
                        },
                    }],
                },
                tooltips: {
                    callbacks: {
                        label: (item, data) => {
                            const label = data.datasets[item.datasetIndex]?.label || '';

                            return `${label}: ${currency.format(Number(item.yLabel) || 0)}`;
                        },
                    },
                },
            },
        });
    };

    const dataset = (label, data, color) => ({
        label,
        data,
        fill: false,
        borderColor: color,
        backgroundColor: color,
        borderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 5,
    });

    const annualCanvas = document.getElementById('chartAnnualDevelopment');
    if (annualCanvas) {
        const development = JSON.parse(annualCanvas.dataset.development || '[]');
        const labels = JSON.parse(annualCanvas.dataset.labels || '{}');
        if (development.length) {
            renderChart(
                annualCanvas,
                development.map((item) => `${labels.labelYear} ${item.Year}`),
                [
                    dataset(labels.labelEarnOfSell, development.map((item) => item.earnOfSell), primary),
                    dataset(labels.labelCashflow, development.map((item) => item.SummarizedCashflow), secondary),
                ]
            );
        }
    }

    const kfwCanvas = document.querySelector('[data-kfw-development-chart]');
    if (kfwCanvas) {
        const before = JSON.parse(kfwCanvas.dataset.before || '[]');
        const after = JSON.parse(kfwCanvas.dataset.after || '[]');
        const labels = JSON.parse(kfwCanvas.dataset.labels || '{}');
        if (before.length && after.length) {
            renderChart(
                kfwCanvas,
                before.map((item) => `${labels.year} ${item.Year}`),
                [
                    dataset(labels.without, before.map((item) => item.earnOfSell), secondary),
                    dataset(labels.with, after.map((item) => item.earnOfSell), primary),
                ]
            );
        }
    }

    const depreciationCanvas = document.querySelector('[data-depreciation-development-chart]');
    if (depreciationCanvas) {
        const development = JSON.parse(depreciationCanvas.dataset.development || '[]');
        const labels = JSON.parse(depreciationCanvas.dataset.labels || '{}');
        if (development.length) {
            renderChart(
                depreciationCanvas,
                development.map((item) => `${labels.year} ${item.year}`),
                [
                    dataset(labels.cumulative, development.map((item) => item.cumulative), primary),
                    dataset(labels.remaining, development.map((item) => item.remaining), secondary),
                ]
            );
        }
    }

    const lbankCanvas = document.querySelector('[data-lbank-development-chart]');
    if (lbankCanvas) {
        const before = JSON.parse(lbankCanvas.dataset.before || '[]');
        const after = JSON.parse(lbankCanvas.dataset.after || '[]');
        const labels = JSON.parse(lbankCanvas.dataset.labels || '{}');
        if (before.length && after.length) {
            renderChart(
                lbankCanvas,
                before.map((item) => `${labels.year} ${item.Year}`),
                [
                    dataset(labels.without, before.map((item) => item.earnOfSell), secondary),
                    dataset(labels.with, after.map((item) => item.earnOfSell), primary),
                ]
            );
        }
    }
});
